import { createTheme, Theme } from "@mui/material";
import { scrollBarStyles } from "./scroll-bar";

// Extend the Palette interface to include custom colors
declare module "@mui/material/styles" {
  interface Palette {
    color1: Palette["primary"];
    color2: Palette["primary"];
    color3: Palette["primary"];
    color4: Palette["primary"];
    color5: Palette["primary"];
    color6: Palette["primary"];
    color7: Palette["primary"];
    color8: Palette["primary"];
    color9: Palette["primary"];
    color10: Palette["primary"];
    color11: Palette["primary"];
    color12: Palette["primary"];
    color13: Palette["primary"];
    color14: Palette["primary"];
    color15: Palette["primary"];
    CommonWhite: Palette["primary"];
    CommonBlack: Palette["primary"];
    available: Palette["primary"];
    occupied: Palette["primary"];
    offline: Palette["primary"];
  }

  interface PaletteOptions {
    color1?: PaletteOptions["primary"];
    color2?: PaletteOptions["primary"];
    color3?: PaletteOptions["primary"];
    color4?: PaletteOptions["primary"];
    color5?: PaletteOptions["primary"];
    color6?: PaletteOptions["primary"];
    color7?: PaletteOptions["primary"];
    color8?: PaletteOptions["primary"];
    color9?: PaletteOptions["primary"];
    color10?: PaletteOptions["primary"];
    color11?: PaletteOptions["primary"];
    color12?: PaletteOptions["primary"];
    color13?: PaletteOptions["primary"];
    color14?: PaletteOptions["primary"];
    color15?: PaletteOptions["primary"];
    CommonWhite: PaletteOptions["primary"];
    CommonBlack: PaletteOptions["primary"];
    available: PaletteOptions["primary"];
    occupied: PaletteOptions["primary"];
    offline: PaletteOptions["primary"];
  }
}

// Define the theme configuration
export const CoffeeShoplightTheme: Theme = createTheme({
  typography: {
    fontFamily: ["Lato", "Arial", "sans-serif"].join(","),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          ...scrollBarStyles,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          "&.MuiTableCell-root.MuiTableCell-head": {
            backgroundColor: "#F5F5DC", // Beige for table header
            color: "#4B3D3D", // Dark Brown for text
          },
        },
      },
    },
  },
  palette: {
    mode: "light", // Enable light mode
    color1: { main: "#D9B89B" }, // Light Coffee Brown
    color2: { main: "#A8D8B9" }, // Soft Mint Green
    color3: { main: "#F2C94C" }, // Golden Yellow
    color4: { main: "#EAB8A1" }, // Soft Peach
    color5: { main: "#BFA6A0" }, // Dusty Rose
    color6: { main: "#F6E7D7" }, // Cream
    color7: { main: "#C4B6A6" }, // Light Taupe
    color8: { main: "#F0E68C" }, // Light Olive
    color9: { main: "#E6B0AA" }, // Blush Pink
    color10: { main: "#B2B2B2" }, // Gray
    color11: { main: "#FFFFFF" }, // Pure White
    color12: { main: "#FAFAFA" }, // Off White
    color13: { main: "#EAEDED" }, // Light Gray
    color14: { main: "#D5DBDB" }, // Soft Gray
    color15: { main: "#B2B2B2" }, // Soft Blue Gray
    CommonWhite: { main: "#FFFFFF" },
    CommonBlack: { main: "#000000" },
    available: { main: "#A8D8B9" }, // Soft Mint Green for available
    occupied: { main: "#F2C94C" }, // Golden Yellow for occupied
    offline: { main: "#D5DBDB" }, // Soft Gray for offline
    primary: {
      main: "#6F4C3E", // Coffee Brown (New Primary)
      contrastText: "#fff", // White for contrast
    },
    secondary: {
      main: "#D9B89B", // Light Coffee Brown
      contrastText: "#000000", // Black for contrast
    },
    error: {
      main: "#EB5757", // Warm Red
      contrastText: "#FFFFFF", // White for contrast
    },
    success: {
      main: "#27AE60", // Emerald Green
      contrastText: "#FFFFFF", // White for contrast
    },
    warning: {
      main: "#F2994A", // Vibrant Orange
      contrastText: "#000000", // Black for contrast
    },
    background: {
      default: "#F5F5DC", // Beige for the default background
      paper: "#FFFFFF", // White for paper elements
    },
    text: {
      primary: "#4B3D3D", // Dark Brown for primary text
      secondary: "#7D7D7D", // Medium Gray for secondary text
    },
    action: {
      hover: "#E2E8F0", // Light Gray for hover states
      selected: "#B2F5EA", // Soft Mint for selected states
    },
  },
});